/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listRecords.defs.js'
export * as $defs from './listRecords.defs.js'
